"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function useGroupedLineItems(lineItems) {
    if (!lineItems) {
        return {
            stickerGroups: {},
            items: [],
        };
    }
    const stickerItems = lineItems.filter(item => item.__typename === "StickerLineItem");
    const items = lineItems.filter(item => item.__typename !== "StickerLineItem");
    const stickerGroups = stickerItems.reduce((groups, item) => {
        if (!groups[item.stickerOrderId]) {
            groups[item.stickerOrderId] = [];
        }
        groups[item.stickerOrderId].push(item);
        return groups;
    }, {});
    return {
        stickerGroups,
        items,
    };
}
exports.default = useGroupedLineItems;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidXNlR3JvdXBlZEl0ZW1zLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vc3JjL2NvbXBvbmVudHMvb3JkZXJzL3VzZUdyb3VwZWRJdGVtcy50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7QUFPQSxTQUF3QixtQkFBbUIsQ0FDekMsU0FBZTtJQUVmLElBQUksQ0FBQyxTQUFTLEVBQUU7UUFDZCxPQUFPO1lBQ0wsYUFBYSxFQUFFLEVBQUU7WUFDakIsS0FBSyxFQUFFLEVBQUU7U0FDVixDQUFDO0tBQ0g7SUFFRCxNQUFNLFlBQVksR0FBSSxTQUFTLENBQUMsTUFBTSxDQUNwQyxJQUFJLENBQUMsRUFBRSxDQUFDLElBQUksQ0FBQyxVQUFVLEtBQUssaUJBQWlCLENBQ2IsQ0FBQztJQUNuQyxNQUFNLEtBQUssR0FBRyxTQUFTLENBQUMsTUFBTSxDQUFDLElBQUksQ0FBQyxFQUFFLENBQUMsSUFBSSxDQUFDLFVBQVUsS0FBSyxpQkFBaUIsQ0FBQyxDQUFDO0lBRTlFLE1BQU0sYUFBYSxHQUFHLFlBQVksQ0FBQyxNQUFNLENBRXRDLENBQUMsTUFBTSxFQUFFLElBQUksRUFBRSxFQUFFO1FBQ2xCLElBQUksQ0FBQyxNQUFNLENBQUMsSUFBSSxDQUFDLGNBQWMsQ0FBQyxFQUFFO1lBQ2hDLE1BQU0sQ0FBQyxJQUFJLENBQUMsY0FBYyxDQUFDLEdBQUcsRUFBRSxDQUFDO1NBQ2xDO1FBQ0QsTUFBTSxDQUFDLElBQUksQ0FBQyxjQUFjLENBQUMsQ0FBQyxJQUFJLENBQUMsSUFBSSxDQUFDLENBQUM7UUFDdkMsT0FBTyxNQUFNLENBQUM7SUFDaEIsQ0FBQyxFQUFFLEVBQUUsQ0FBQyxDQUFDO0lBQ1AsT0FBTztRQUNMLGFBQWE7UUFDYixLQUFLO0tBQ04sQ0FBQztBQUNKLENBQUM7QUE1QkQsc0NBNEJDIn0=